import { render } from "./TracesSection.vue?vue&type=template&id=894412b0&scoped=true"
import script from "./TracesSection.vue?vue&type=script&lang=js"
export * from "./TracesSection.vue?vue&type=script&lang=js"

import "./TracesSection.vue?vue&type=style&index=0&id=894412b0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-894412b0"]])

export default __exports__